
export async function GetImage(startIndex, ammount, username = null, gallery = null){

    let URL = "";

    if (gallery != null && username != null) {
        URL = `/api/gallery/${username}/${gallery}?ammount=${ammount}&offset=${startIndex}`;
    }
    else if (username != null) {
        URL = `/api/gallery/profiles/posts?ammount=${ammount}&offset=${startIndex}&username=${username}`;
    }
    else {
        URL = `/api/gallery?ammount=${ammount}&offset=${startIndex}`;
    }
        
    try{
        
        const response = await fetch(URL, {
            method: "GET",
            headers: {
                "Content-Type":"application/json"
            }
        });

        const responseData = await response.json();
        return responseData.data || [];  

    } catch(error){
        console.error(error);
        return [];
    }

}


export default GetImage